import {Card, Empty, List, Spin} from 'antd';

import {Locale} from '../../../../../../provider/locale/locale';
import {useLocale} from '../../../../../../provider/locale/locale-hook';
import {useAiMonitoringRecommendations} from '../../../../../../service/ai-brand-monitoring/ai-brand-monitoring-hook';

type PropsType = {
    brandId: number;
    runId: string | null;
};

export function RecommendationsBlock(props: PropsType): JSX.Element {
    const {brandId, runId} = props;
    const {getLocalizedString} = useLocale();

    const {data, isLoading} = useAiMonitoringRecommendations(brandId, runId);

    const items = data?.items ?? [];

    return (
        <Card size="small" title={<Locale stringKey="AI_BRAND_MONITORING__DASHBOARD__RECOMMENDATIONS" />}>
            {isLoading ? (
                <Spin />
            ) : items.length > 0 ? (
                <List<string> dataSource={items} renderItem={(item) => <List.Item>{item}</List.Item>} size="small" />
            ) : (
                <Empty description={getLocalizedString('AI_BRAND_MONITORING__DASHBOARD__NO_RECOMMENDATIONS')} />
            )}
        </Card>
    );
}
